import Navbar from "./navbar";

export default function Nav() {
  return <Navbar />;
}
